<template>
    <website-page>
        <wifi-navigation></wifi-navigation>
        <div class="main-section overlay">
            <b-container>
                <h1 class="blured">
                    <div v-tr>WiFi portal for|Le portail WiFi</div>
                    <div v-tr>businesses and professionals|des professionnels</div>
                </h1>
                <h3 class="subtitle blured" v-tr>No matter your industry, we have a solution for you|Peu importe votre domaine, nous avons la solution pour vous</h3>
                <p class="presentation" v-tr>
                    Shopping Malls, Retailers, Real-Estate, Transports, Quick Service Restaurants, Schools and Universities, Banks and much more...|
                    Centres commerciaux, détaillants, immobilier, transports, restaurants à service rapide, écoles et universités, banques et bien plus encore ...
                </p>
                <b-row class="mt-5">
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/transdev.png')" alt="Client Transdev"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/eye-in-client-king-charters.png')" alt="Client WiFi King Charters"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/cominar.png')" alt="Client WiFi Cominar"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/grevin_montreal.png')" alt="Client WiFi Musee Grévin Montréal"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/place_rosemere.png')" alt="Client WiFi Shopping Mall Place Rosemere"></b-img>
                    </b-col>
                    <b-col cols="6" md="4" xl="2" class="client">
                        <b-img :src="require('../../assets/img/clients-white/client-place-des-arts.png')" alt="Client Place des Arts"></b-img>
                    </b-col>
                </b-row>

                <div class="mt-5">
                    <b-btn v-scroll-to="'#contact-us'" class="mr-2" variant="primary"><span v-tr>Contact Us|Contactez-nous</span></b-btn>
                    <b-btn  v-if="!isMobileLayout"  v-scroll-to="'#markets'" variant="outline-light"><span v-tr>Our Markets|Nos marchés</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
                </div>
            </b-container>
        </div>

        <div id="markets" class="page">
            <b-container>
                <h3 class="text-center" v-tr>Our Markets|Nos marchés</h3>
                <b-row>
                    <feature-card src="img/icons/shopping-mall.png" alt="Shopping Mall Free WiFi Solution">
                        <h4 v-tr>Shopping Malls|Centre commerciaux</h4>
                        <p v-tr>
                            Provide industry leading shopping experience.|Offrez la meilleur expérience de magasinage
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/retail.png" alt="Retail WiFi WiFi Marketing Solution">
                        <h4 v-tr>Retail|Vente au détail</h4>
                        <p v-tr>
                            Attract, impress and convert your customers.|Attirez, impressionnez et convertissez vos clients
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/transportation.png" alt="Transportation WiFi Portal Solution">
                        <h4 v-tr>Transportation|Transports</h4>
                        <p v-tr>
                            Enable your passengers to be connected and productive at all times.|
                            Permettez à vos passagers d'être connectés et productifs à tout moment.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/bank.png" alt="Banking public WiFi solution">
                        <h4 v-tr>Banking|Banques</h4>
                        <p v-tr>
                            The perfect solution to gather data during your events.|
                            La solution parfaite pour collecter des données lors de vos évènements
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/tea.png" alt="Guest & Social WiFi for Restaurants & QSR">
                        <h4 v-tr>Quick Service Restaurants|Restauration rapide</h4>
                        <p v-tr>
                            Create dynamic and captivating menus to increase your sales.|
                            Améliorez l'expérience de vos clients et augmentez vos revenus.
                        </p>
                    </feature-card>
                    <feature-card src="img/icons/museum.png" alt="Public WiFi Hotspot for Municipalities & Arenas">
                        <h4 v-tr>Municipalities / Arenas|Municipalités / Arénas</h4>
                        <p v-tr>
                            Capture your citizens' attention with key messages.|
                            Informez vos visiteurs avec votre propre contenu.
                        </p>
                    </feature-card>
                </b-row>
            </b-container>

            <div class="text-center">
                <b-btn v-if="!isMobileLayout" class="mt-4" v-scroll-to="'#testimonials'" variant="light"><span v-tr>What they say about us|Ce qu'ils disent de nous</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
            </div>
        </div>

        <div id="testimonials" class="page inverted text-center">
            <h3 v-tr>Testimonials|Témoignages</h3>
            <h5 v-tr>What they say about us|Ce qu'ils disent à propos de nous</h5>
            <testimonial-card name="Sébastien Boudrias" client-since="2007"
                              :job="'CIO and Telecommunications Transdev Canada|Directeur Informatique et Télécommunications Transdev Canada'|tr"
                              :src="require('../../assets/img/clients-color/transportation/transdev.png')">
                <span v-tr>
                    Thank you Eye-In Media for 8 years of oustanding service. Your dynamic and competent team remarkably understands how to concretize your customers’ requirements.|
                    Merci Eye-In Media. Déjà 8 ans de précieux services avec leur équipe dynamique et compétente qui comprend et concrétise les besoins de ses clients.
                </span>
            </testimonial-card>
            <testimonial-card name="Robert" client-since="2016"
                              job="King Charters"
                              :src="require('../../assets/img/clients-color/transportation/king_charters.png')">
                <p>
                    Strong and reliable internet coverage.
                    Eye-in Media's monthly fees are very reasonable, and they don't have hidden fees.
                </p>
                <span>
                    If you don't have WiFi on your bus you are making a mistake. Eye-in Media will get you set-up quickly.
                    King Charters has been using Eye-in Media for over a year. We are so happy with the service we would not consider another company.
                </span>
            </testimonial-card>
            <testimonial-card name="Zeina Barghout" client-since="2006"
                              job="Directrice Marketing Centre Eaton de Montréal"
                              :src="require('../../assets/img/clients-color/shopping-center/centre_eaton.png')"
                              ><span v-tr>The Montreal Eaton Center has been using Eye-In services since 2006. We wanted to share with you our satisfaction with the services provided by your company. The job has always been done on time and delivered on time in a very professional manner.|
                Le Centre Eaton de Montréal ayant recours aux services de Eye-In depuis 2006. nous désirions vous faire part de notre satisfaction vis à vis des services rendus par votre entreprise. Le travail a toujours été fait en respectant les délais et livrés en temps et en heure de façon très professionnelle. D’ailleurs, à ce sujet, Eye-In a eu, à quelques reprises, à travailler sur quelques projets aux délais très serrés, mais en aucun cas le travail n’en a souffert.
                Eye-In travaille de près avec le client pour bien comprendre les besoins et livrer le matériel demandé. Le suivi est toujours exécuté avec le souci du travail bien fait et Eye-In s’assure que le mandat est rempli du début à la fin. Le support technique ainsi que le soutien du service à la clientèle sont très bien assumés par Eye-In.
                </span>
            </testimonial-card>
            <testimonial-card name="Jack Craven" client-since="2015"
                              job="Quick Coach Lines"
                              :src="require('../../assets/img/clients-color/transportation/quick_coach_shuttle.png')">
                <p>Quick Coach Lines runs a scheduled coach service between Vancouver BC and Seattle Tacoma Airport. We offer free WiFi on all departures and in the past have had many issues with connectivity. Something that was Free to our clients and was suppose to be good feature was turning into a problem with all complaints and requests for refunds.</p>
                <span>We switched our service over to Eye in Media in November 2015 and all of problems we were having are no longer. My account rep Margie is always available to help me with their system and I was able to contract out our Log in and Landing page for a one year term that helped offset some of our costs. If you are looking for a better service or thinking about starting up one, I would recommend Eye-In Media to make the transition an easy one.</span>
            </testimonial-card>

            <div class="text-center">
                <b-btn v-if="!isMobileLayout" class="mt-5" v-scroll-to="'#clients'" variant="outline-light"><span v-tr>They Chose Us|Ils nous ont choisis</span> <i class="fal fa-chevron-down ml-1"></i></b-btn>
            </div>
        </div>

        <div id="clients" class="page bg-light">
            <b-container>
                <h3 class="text-center mb-3" v-tr>They chose us|Ils nous ont choisis</h3>

                <h4><i class="fal fa-guitars mr-2"></i> <span v-tr>Arts & Entertainment|Arts et spectacles</span></h4>
                <wifi-entertainment-client-card></wifi-entertainment-client-card>

                <h4 class="mt-3"><i class="fal fa-building mr-2"></i> <span v-tr>Shopping Mall|Centre commerciaux</span></h4>
                <wifi-shopping-mall-client-cards></wifi-shopping-mall-client-cards>

                <h4 class="mt-3"><i class="fal fa-city mr-2"></i> <span v-tr>Real Estate|Immobilier</span></h4>
                <wifi-real-estate-client-card></wifi-real-estate-client-card>

                <h4 class="mt-3"><i class="fal fa-bus mr-2"></i> <span v-tr>Bus & Transports|Bus et Transports</span></h4>
                <wifi-transportation-client-cards></wifi-transportation-client-cards>

                <h4 class="mt-3"><i class="fal fa-store-alt mr-2"></i> <span v-tr>Retail and Manufacturers|Détaillants et manufactures</span></h4>
                <wifi-other-client-cards></wifi-other-client-cards>

                <h4 class="mt-3"><i class="fal fa-utensils-alt mr-2"></i> <span v-tr>Restaurants|Restauration</span></h4>
                <wifi-restauration-client-card></wifi-restauration-client-card>

                <h4 class="mt-3"><i class="fal fa-utensils-alt mr-2"></i> <span v-tr>Municipalities|Villes</span></h4>
                <wifi-municipalities-client-card></wifi-municipalities-client-card>
            </b-container>
        </div>
    </website-page>
</template>

<script>
    import WifiEntertainmentClientCard from "@/client-cards/wifi-entertainment-client-cards.vue";
    import WifiMunicipalitiesClientCard from "@/client-cards/wifi-municipalities-cards.vue";
    import WifiOtherClientCards from "@/client-cards/wifi-other-client-cards.vue";
    import WifiRealEstateClientCard from "@/client-cards/wifi-real-estate-client-cards.vue";
    import WifiRestaurationClientCard from "@/client-cards/wifi-restauration-client-cards.vue";
    import WifiShoppingMallClientCards from "@/client-cards/wifi-shopping-mall-client-cards.vue";
    import WifiTransportationClientCards from "@/client-cards/wifi-transportation-client-cards.vue";

    import WifiNavigation from "@/navigation/wifi-navigation.vue";
    import {translate} from "../../../vue-components/helpers/i18n.js";
    export default {
        name: `wifi-clients`,
        components: {
            WifiMunicipalitiesClientCard,
            WifiRealEstateClientCard,
            WifiShoppingMallClientCards,
            WifiOtherClientCards,
            WifiEntertainmentClientCard,
            WifiRestaurationClientCard,
            WifiTransportationClientCards,
            WifiNavigation
        },
        metaInfo: {
            title: translate(`Guest WiFi Portal for Shopping Mall, Retail, Transportation, Banking, Quick Service Restaurants|Portail WiFi invité pour centre commercial, vente au détail, transport, banque, restaurants à service rapide`),
            meta: [
                { name: `keywords`, content: `shopping, shopping mall, retail, transports, bus, banking, restaurants, fast-foods, wifi, guest wifi, social wifi, wifi portal` },
                { name: `description`, content: translate(`Provide industry leading shopping experience. Attract, impress and convert your customers.|Offrez une expérience de magasinage à la pointe de l'industrie. Attirez, impressionnez et convertissez vos clients.`) }
            ]
        }
    }
</script>

<style lang="scss" scoped>
    .main-section {
        background-color: #151e28;
        background-image: url('../../assets/img/backgrounds/clients.jpg');
        background-image: url('../../assets/img/backgrounds/clients.webp');
        background-size: cover;
    }

    .icon-list {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .fal,
        .fas {
            opacity: 0.8;
            font-size: 36px;
            padding: 15px;
            display: inline-flex;
            margin: 0 auto;
        }
    }
</style>
